import { ElmFrameworkPorts } from '../../ElmFrameworkPorts';
import {eventAssigner, getApiUrl, getBaseUrl} from '../util';
import { isWatcherPage, watcherNavigationUrl, watcherPagePath } from '../../../watcherLinks';

export {
  toLocation,
  handleNavigation,
  NavLocation,
  RoutingCmdMap,
};


function handleNavigation(appPorts: ElmFrameworkPorts): void {
  // handleAnchorClicks(appPorts);
  window.addEventListener('popstate', e => {
    if (!permitFramedNavigation(watcherPagePath(location.pathname, location.hash))) return;
    // Follow the URL even when the build omits Elm's history subscription.
    if (!appPorts.popState) return document.location.reload();
    appPorts.popState.send({
      stateIndex: e.state?.stateIndex ?? 0,
      location: toLocation(),
    });
  });

  appPorts.routingCommands.subscribe(cmds => cmds.forEach(eventAssigner(routingHandlers, 'kind')));

  appPorts.navToLoopback?.subscribe(cmd => {
    if (!permitFramedNavigation(new URL(cmd.url, location.origin).pathname)) return;
    appPorts.navToLoopbackSub.send({
      navigationLocation: toLocation(cmd.url),
      shouldReplace: cmd.shouldReplace,
      shouldSilent: cmd.shouldSilent,
    });
  });

  // skipCache boolean argument only works on Firefox, it gets ignored by every other browser out there
  // @ts-ignore
  appPorts.reloadApp?.subscribe(skipCache => document.location.reload(skipCache));
}

const routingHandlers: { [key in keyof RoutingCmdMap]: (e: RoutingCmdMap[key]) => void } = {
  go: ({steps}) => history.go(steps),
  pushState: e => updateHistory("pushState", e),
  replaceState: e => updateHistory("replaceState", e),
};

function updateHistory(kind: "pushState" | "replaceState", e: RoutingCmdMap["pushState"]): void {
  const target = new URL(getBaseUrl() + e.url);
  const path = target.pathname + target.search + target.hash;
  if (!permitFramedNavigation(target.pathname)) return;
  history[kind]({stateIndex: e.stateIndex}, e.title, watcherNavigationUrl(path, sessionStorage));
}

function permitFramedNavigation(path: string): boolean {
  if (window.self !== window.top && !isWatcherPage(path)) {
    // A frameable watcher document must never become a sign-in/settings SPA.
    // Empty it immediately, then load a route whose HTTP policy denies framing.
    document.body.replaceChildren();
    window.location.replace(new URL("login", getBaseUrl()).href);
    return false;
  }
  return true;
}


interface RoutingCmdMap {
  pushState: { stateIndex: number, title: string, url: string }
  replaceState: { stateIndex: number, title: string, url: string }
  go: { steps: number }
}

// function handleAnchorClicks(appPorts: ElmFrameworkPorts): void {
//   document.body.addEventListener('click', e => {
//     if (shouldIgnore(e)) return true;
//     const anchor = toAnchor(e);
//     if (anchor && isInboundHref(anchor)) {
//       handleEvent(e, anchor, appPorts);
//     } else {
//       return true;
//     }
//   });
//
//   function handleEvent(e: MouseEvent, anchor: HTMLAnchorElement, appPorts: ElmFrameworkPorts): void {
//     e.preventDefault();
//     history.pushState({}, '', anchor.getAttribute('href'));
//     appPorts.receiveNewLocation.send({location: toLocation(), shouldReplace: false});
//   }
//
//
//   function toAnchor(e: MouseEvent): HTMLAnchorElement | undefined {
//     for (let n = <HTMLElement>e.target; n.parentNode; n = <HTMLElement>n.parentNode) {
//       if (n.nodeName === 'A') {
//         return <HTMLAnchorElement>n;
//       }
//     }
//   }
//
//   function isInboundHref(el: HTMLAnchorElement): boolean {
//     return location.hostname === el.hostname;
//   }
//
//
//   function shouldIgnore(e: MouseEvent): boolean {
//     return e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented;
//   }
// }


const toLocation = (pathname?: string): NavLocation => ({
  href: document.location.href,
  host: document.location.host,
  hostname: document.location.hostname,
  protocol: document.location.protocol,
  origin: document.location.origin,
  port_: document.location.port,
  pathname: pathname || watcherPagePath(document.location.pathname, document.location.hash),
  search: pathname ? '' : document.location.search,
  hash: document.location.hash,
});

interface NavLocation {
  href: string
  host: string
  hostname: string
  protocol: string
  origin: string
  port_: string
  pathname: string
  search: string
  hash: string
}
